export const FEE = 0.05; // 5% fee
